<template>
  <nav class="navigation-links-nav" v-bind:class="rootClassName">
    <router-link
      to="/despre-noi"
      class="navigation-links-navlink1 Navigation-Link"
    >
      {{ link1 }}
    </router-link>
    <router-link
      to="/reparatii-auto"
      class="navigation-links-navlink2 Navigation-Link"
    >
      {{ link2 }}
    </router-link>
    <router-link to="/news" class="navigation-links-navlink3 Navigation-Link">
      {{ link3 }}
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'NavigationLinks',
  props: {
    rootClassName: String,
    link2: {
      type: String,
      default: 'servicii',
    },
    link3: {
      type: String,
      default: 'noutati',
    },
    link1: {
      type: String,
      default: 'despre noi',
    },
  },
}
</script>

<style scoped>
.navigation-links-nav {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  flex-direction: row;
}
 
.navigation-links-navlink1 {
  color: var(--dl-color-scheme-white);
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
}
 
.navigation-links-navlink1:hover {
  color: var(--dl-color-scheme-pink);
}
 
.navigation-links-navlink2 {
  color: var(--dl-color-scheme-white);
  cursor: pointer;
  transition: 0.3s;
  margin-left: 41px;
  text-decoration: none;
}
 
.navigation-links-navlink2:hover {
  color: var(--dl-color-scheme-pink);
}
 
.navigation-links-navlink3 {
  color: var(--dl-color-scheme-white);
  cursor: pointer;
  transition: 0.3s;
  margin-left: 41px;
  text-decoration: none;
}
 
.navigation-links-navlink3:hover {
  color: var(--dl-color-scheme-pink);
}
 

 

 

 

 

 

 

 

 

 

 

 

 
@media(max-width: 767px) {
  .navigation-links-nav {
    align-items: flex-start;
    flex-direction: column;
  }
  .navigation-links-navlink1 {
    margin-bottom: var(--dl-space-space-unit);
  }
  .navigation-links-navlink2 {
    margin-left: 0;
    margin-bottom: var(--dl-space-space-unit);
  }
  .navigation-links-navlink3 {
    margin-left: 0;
    margin-bottom: var(--dl-space-space-unit);
  }
}
</style>
